import { QuestionComponentProps } from "..";

import { PositiveSectorTagsSelector } from "./components/PositiveSectorTagsSelector";

export function PositiveSectorTags({
  setNextEnabled,
}: QuestionComponentProps): React.ReactElement {
  return (
    <PositiveSectorTagsSelector
      onPreferenceSet={(isPreferenceSet: boolean) =>
        setNextEnabled?.(isPreferenceSet)
      }
    />
  );
}
